import Axios, { type AxiosError, type AxiosRequestConfig, type AxiosResponse } from 'axios'

export const AxiosInstance = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY ?? '',
  },
})

export type LXResponse<T> = { headers: AxiosResponse['headers']; body: T }

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<LXResponse<T>> => {
  const source = Axios.CancelToken.source()
  const promise = AxiosInstance({
    ...config,
    ...options,
    cancelToken: source.token,
  }).then(({ data, headers }: AxiosResponse) => {
    return {
      headers: headers,
      body: data,
    }
  })

  // @ts-ignore Property 'cancel' does not exist on type 'Promise<any>'
  promise.cancel = () => {
    source.cancel('Query was cancelled')
  }

  return promise
}

// In some case with react-query and swr you want to be able to override the return error type so you can also do it here like this
export type ErrorType<Error> = AxiosError<Error>
